module.exports = __webpack_public_path__ + "cdcce56d6a7ca54255e9fd2ba135acab.MP3";